import { createNode, TimeLikeUnion } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { objectToTemporal } from '../../utils/temporal';

export const GetTimeInfo = createNode({
    id: 'Get Time Info',
    name: 'Get Time Info',
    description: 'Extracts time components from a Time, DateTime, or ZonedDateTime',
    aiDescription:
        'Takes a time-like value on the "Value" port (Time, DateTime, or ZonedDateTime) and outputs its components on "Hour", "Minute", "Second", and "Millisecond" ports.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Value: { kind: 'generic', identifier: 'T', extends: TimeLikeUnion },
    },
    outPorts: {
        Hour: { kind: 'number' },
        Minute: { kind: 'number' },
        Second: { kind: 'number' },
        Millisecond: { kind: 'number' },
    },
    execute: function (input) {
        const temporal = objectToTemporal(input.inPorts.Value);

        let timeLike: { hour: number; minute: number; second: number; millisecond: number };
        if (temporal instanceof Temporal.ZonedDateTime) {
            timeLike = temporal.toPlainTime();
        } else if (temporal instanceof Temporal.PlainDateTime) {
            timeLike = temporal.toPlainTime();
        } else {
            timeLike = temporal as Temporal.PlainTime;
        }

        return {
            output: {
                Hour: timeLike.hour,
                Minute: timeLike.minute,
                Second: timeLike.second,
                Millisecond: timeLike.millisecond,
            },
        };
    },
});
